import type { StyleRule } from '@archipro-design/aria';
import { pxToRem } from '@archipro-design/aria';
import type { Position } from '@modules/directory/component/StickyAction';

/**
 * reason to also support px values is to match legacy or external ui
 * example usecase: back-to-top button consistent with the intercom button
 */
const pxOrRem = (value: number, usePxValues: boolean) => {
    return usePxValues ? `${value}px` : pxToRem(value);
};

export const StickyActionContainer: StyleRule<{
    position: Position;
    width?: number;
    height: number;
    usePxValues: boolean;
    visible: boolean;
}> = ({ theme, position, width, height, usePxValues, visible }) => ({
    position: 'sticky',
    zIndex: theme.siteVariables.zIndexes.menuItem,
    overflow: 'hidden',
    width: width ? pxOrRem(width, usePxValues) : '100%',
    height: visible ? pxOrRem(height, usePxValues) : 0,
    top:
        typeof position.top === 'number'
            ? pxOrRem(position.top, usePxValues)
            : 'auto',
    bottom:
        typeof position.bottom === 'number'
            ? pxOrRem(position.bottom, usePxValues)
            : 'auto',
    left:
        typeof position.left === 'number'
            ? pxOrRem(position.left, usePxValues)
            : typeof position.right === 'number' && width
            ? `calc(100% - ${pxOrRem(width + position.right, usePxValues)})`
            : 'auto',
    transition: 'all 200ms ease',
});
